/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Assignment list styles
 *
 * @file assignmentListStyles.js
 * @author Gladson Samuel S
 * @since 2.0.0
 */

import { styled } from '@mui/material/styles';
import mixins from '../../../assets/styles/mixins.scss';
import CommonStyles from '../../../assets/styles/CommonStyles';
import { createScopedClasses, createScopedStyles } from '../../../assets/styles/createScopedStyles';

const scrollStyles = CommonStyles().scrollContainer({
  scrollbarWidth: 4,
  scrollbarColor: '#e8e6f3 transparent',
  borderRadius: 8
});

const assignmentListStyles = {
  emptyState: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 24,
    padding: 24,
    textAlign: 'center'
  },
  emptyStateIcon: {
    width: 64,
    height: 64,
    borderRadius: '50%',
    backgroundColor: mixins.badgeBgColor,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
      fontSize: 28,
      color: mixins.amethyst
    }
  },
  emptyStateTitle: {
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: 20,
    fontWeight: mixins.fontWeight500,
    lineHeight: '28px',
    letterSpacing: '-0.4px',
    color: mixins.color_text_primary,
    margin: 0
  },
  emptyStateDescription: {
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: 14,
    fontWeight: mixins.fontWeight500,
    lineHeight: '22px',
    color: mixins.color_text_primary,
    margin: 0
  },
  assignmentList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    width: '100%',
    maxHeight: 560,
    ...scrollStyles
  },
  scheduleListPane: {
    borderRadius: 16,
    boxSizing: 'border-box',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0
  },
  scheduleAssignmentList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    width: '100%'
  }
};

export const classes = createScopedClasses('aet-assignment-list', assignmentListStyles);

export const scopedStyles = createScopedStyles(assignmentListStyles, classes);

export const AssignmentListStylesRoot = styled('div')(scopedStyles);

export default assignmentListStyles;
